import {
  GET_CARPARK_FAIL,
  GET_CARPARKS_SUCCESS,
  GET_CARPARK_DETAIL_FAIL,
  GET_CARPARK_DETAIL_SUCCESS,
  ADD_CARPARK_SUCCESS,
  ADD_CARPARK_FAIL,
  UPDATE_CARPARK_SUCCESS,
  UPDATE_CARPARK_FAIL,
  CLEAR_MESSAGE,
  DELETE_CARPARK_SUCCESS,
  DELETE_CARPARK_FAIL,
  GET_CARPARK_OCCUPANCY_RATE_FAIL,
  GET_CARPARK_OCCUPANCY_RATE_SUCCESS,  
  GET_EXPORT_OCCUPANCY_RATE,
  GET_EXPORT_OCCUPANCY_RATE_SUCCESS,
  GET_EXPORTED_OCCUPANCY_RATE_FAIL,
  RESET_EXPORT_DATA,
} from "./actionTypes"

const INIT_STATE = {
  carParkList: [],
  carParkDetails: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
  occupancyRate: [],
  occupancyRatePagination: {},
}

const carPark = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CARPARKS_SUCCESS:
      return {
        ...state,
        carParkList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }
    case GET_CARPARK_FAIL:
      return {
        ...state,
        error: action.payload,
        carParkList: [],
      }
    case GET_CARPARK_OCCUPANCY_RATE_SUCCESS:
      return {
        ...state,
        occupancyRate: action.payload?.data,
        occupancyRatePagination: action.payload?.pagination || {}
      }
    case GET_CARPARK_OCCUPANCY_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
        occupancyRate: [],
      }
    case ADD_CARPARK_SUCCESS:
      console.log("action?.payload?.data", action?.payload?.data)
      let carparks = [...state.carParkList]
      carparks.unshift(action?.payload?.data)
      return {
        ...state,
        carParkList: carparks,
        message: action?.payload?.message || "",
      }

    case ADD_CARPARK_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CARPARK_DETAIL_SUCCESS:
      return {
        ...state,
        carParkDetails: action.payload,
      }

    case UPDATE_CARPARK_SUCCESS:
      return {
        ...state,
        message: "Successfully user updated!",
        carParkList: (state?.carParkList || []).map(user => {
          return user._id.toString() === action.payload?.data._id.toString()
            ? { user, ...action.payload?.data }
            : user
        }),
      }

    case UPDATE_CARPARK_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CARPARK_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CARPARK_SUCCESS:
      let list = state?.carParkList || []
      const findIndex = list.findIndex(
        user => user._id.toString() === action.payload._id.toString()
      )
      if (findIndex > -1 && list.length > 0) {
        list[findIndex].status = "Removed"
      }
      return {
        ...state,
        message: "Carpark removed successfully!",
        carParkList: list,
      }

    case DELETE_CARPARK_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    case GET_EXPORT_OCCUPANCY_RATE:
      return {
        ...state,
        isLoading: true,
      }
    case GET_EXPORT_OCCUPANCY_RATE_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
        isLoading: false,
      }

    case GET_EXPORTED_OCCUPANCY_RATE_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
        isLoading: false,
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }

    default:
      return state
  }
}

export default carPark
